import "./VideoTutorial.scss";
import React, { useState, useEffect } from "react";
import { Button, ButtonType } from "../Components";
import { MdHelpOutline } from "react-icons/md";
import { VideoInfo } from "./videoTutorialUtils";
import Tray from "./Tray";
interface VideoTutorialProps {
  showHelpButton: boolean;
  videoList: VideoInfo[] | undefined;
}

const VideoTutorial: React.FC<VideoTutorialProps> = ({ showHelpButton, videoList }) => {
  const [showVideoTray, setShowVideoTray] = useState<boolean>(false);
  const [videoContentList, setVideoContentList] = useState<VideoInfo[]>([]);
  useEffect(() => {
    if (videoList) {
      setVideoContentList(videoList);
    }
  }, [videoList]);

  const helpButtonView = (
    <div className="buttonContainer">
      <Button
        className="helpPillButton"
        size="lg"
        type={ButtonType.FILLED}
        icon={<MdHelpOutline className="helpButtonQuestionIcon" />}
        title="Help"
        onClick={() => setShowVideoTray(true)}
      />
    </div>
  );

  const trayView = showVideoTray ? (
    <Tray setShowExpandedTray={setShowVideoTray} videoList={videoContentList}></Tray>
  ) : (
    <div />
  );
  return (
    <div>
      {showHelpButton && helpButtonView}
      {showVideoTray && trayView}
    </div>
  );
};

export default VideoTutorial;
